import { defineStore } from 'pinia';
import { getUserInfo } from '@/service/login';
import { setLocalStorage, userID } from '@/tool/localStore';
export const initUserData = {
  id: 0,
  nickName: '',
  avatarUrl: '',
};

export interface UserData extends Partial<typeof initUserData> {
  [x: string]: any;
}

export interface UserInfo {
  baseResponse?: any[];
  [key: string]: any; // 允许任意其他字段
}

// 第一个参数是应用程序中 store 的唯一 id
export const useUserStore = defineStore('User', {
  // 推荐使用 完整类型推断的箭头函数
  state: () => {
    return {
      userData: JSON.parse(JSON.stringify(initUserData)) as UserData,
      userInfo: {} as UserInfo, // 明确类型
      token: '',
      isLogin: false,
      tokenTime: '',
      baseId: '',
      baseName: '',
      baseInfo: {
        baseName: '',
      },
    };
  },
  actions: {
    /**
     * 设置用户信息
     * @param data 用户信息
     * @param mode 覆盖模式，0覆盖已有的，1全部覆盖
     */
    setUserData(data: UserData = {}, mode: number = 0) {
      if (mode === 0) {
        this.userData = { ...this.userData, ...data };
      } else if (mode === 1) {
        this.userData = { ...data };
      }
    },
    delUserData() {
      this.userData = JSON.parse(JSON.stringify(initUserData));
    },
    // getAsyncUserInfo() {
    //   getUserInfo().then(res => {
    //     this.userInfo = res.data;
    //     let userId = res.data?.userId || res.data?.user;
    //     setLocalStorage(userID, userId);
    //   });
    // },
    async getAsyncUserInfo() {
      try {
        const res = await getUserInfo();
        const data = res.data;

        this.userInfo = {
          ...this.userInfo,
          ...data,
          baseResponse: data.baseResponse || this.userInfo.baseResponse || [],
        };

        const userId = data?.userId || data?.user;
        setLocalStorage(userID, userId);
      } catch (error) {
        console.error('获取用户信息失败', error);
      }
    },
    setBaseId(baseId: any) {
      console.log('基地改变 --pinia', baseId);
      this.baseId = baseId;
    },
    setCurrentBase(base: any) {
      console.log('当前选中基地--pinia', base);
      this.baseInfo = base;
    },
  },
  getters: {
    getUserInfos: state => {
      return state?.userInfo;
    },
    getBaseId: state => {
      return state.baseId;
    },
    getUserId: state => {
      return state.userInfo?.userId || null;
    },
    getUserName: state => {
      return state.userInfo?.realName || null
    },
    getCurrentBase: state => {
      return {
        ...state.baseInfo,
      };
    },
  },
  // 持久化存储
  persist: true,
});
